<div class="container-fluid d-flex flex-column pt-4 pt-md-5">
    <div class="row">
        <i class="btn-close icon-edponline-Bop-071" (click)="dismiss()"  aria-hidden="true"></i>
        <div class="col-11">
            <h3 class="font-mulish font-weight-normal text-uppercase mt-md-2"
                [ngClass]="{ 'span-easy': pack.type === 1, 'span-smart': pack.type === 2, 'span-full': pack.type === 3 }"
                [innerHTML]="'pt.edp.edponline.pack.health-plan.modal.title' | translate">
            </h3>
        </div>
    </div>
    <div class="row">
        <div class="col-12 subtitle">
            {{ "pt.edp.edponline.pack.health-plan.modal.subtitle" | translate }}
        </div>
    </div>
    <div class="row">
        <div class="col-12 px-0 px-md-3">
            <ngb-accordion [closeOthers]="true" #acc="ngbAccordion" (panelChange)="setCurrentPanel($event)">
                <ngb-panel *ngFor="let form of forms; let i = index" id="dependent-{{ i }}">
                    <ng-template ngbPanelTitle>
                        <span class="step">
                            <span class="circled-number d-inline-flex align-items-center justify-content-center rounded-circle" role="presentation">
                                {{ i + 1 }}
                            </span>
                            <ng-container *ngIf="!form.controls.name.valid">
                                <h5 class="font-mulish font-weight-normal mt-2"> {{ "pt.edp.edponline.pack.health-plan.beneficiario" | translate }}</h5>
                            </ng-container>
                            <ng-container *ngIf="form.controls.name.valid">
                                <h5 class="font-mulish font-weight-normal mt-2"> {{ form.controls.name.value }}</h5>
                            </ng-container>
                            <i [ngClass]="{ 'icon-edponline-Bop-073': currentPanel !== i, 'icon-edponline-arrow-up': currentPanel === i }" aria-hidden="true"></i>
                        </span>
                        <i class="icon-edponline-Bra-068 btn-remove d-none d-lg-inline-block" aria-hidden="true" (click)="removeDependent(i)"  aria-hidden="true"></i>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <form [formGroup]="form">
                            <div class="input-container fluid">
                                <label class="text-label">{{ "pt.edp.edponline.pack.health-plan.nome-completo" | translate }}*</label>
                                <input
                                    type="text"
                                    placeholder="{{ 'pt.edp.edponline.pack.health-plan.nome-completo' | translate }}"
                                    formControlName="name"
                                    [ngClass]="{ error: form.controls.name.invalid && isSubmited }"
                                />
                                <span class="error" *ngIf="form.controls.name.invalid && isSubmited">
                                    {{ "pt.edp.edponline.form.requiredField" | translate }}
                                </span>
                            </div>
                            <div class="inputs-container">
                                <div class="input-container">
                                    <label class="text-label">{{ "pt.edp.edponline.pack.health-plan.telefone" | translate }}*</label>
                                    <input
                                        type="tel"
                                        maxlength="9"
                                        placeholder="210000000"
                                        formControlName="phone"
                                        [ngClass]="{ error: form.controls.phone.invalid && isSubmited }"
                                    />
                                    <span class="error" *ngIf="form.controls.phone.hasError('required') && isSubmited">
                                        {{ "pt.edp.edponline.form.requiredField" | translate }}
                                    </span>
                                    <span class="error" *ngIf="form.controls.phone.hasError('pattern') && isSubmited">
                                        {{ "pt.edp.edponline.form.phone-invalid" | translate }}
                                    </span>
                                </div>
                                <div class="input-container">
                                    <label class="text-label">{{ "pt.edp.edponline.pack.health-plan.nif" | translate }}*</label>
                                    <input
                                        type="text"
                                        maxlength="9"
                                        placeholder="{{ 'pt.edp.edponline.pack.health-plan.nif' | translate }}"
                                        formControlName="nif"
                                        [ngClass]="{ error: form.controls.nif.invalid && isSubmited }"
                                    />
                                    <span class="error" *ngIf="form.controls.nif.hasError('required') && isSubmited">
                                        {{ "pt.edp.edponline.form.requiredField" | translate }}
                                    </span>
                                    <span class="error" *ngIf="form.controls.nif.hasError('nif') && isSubmited">
                                        {{ "pt.edp.edponline.form.nif-invalid" | translate }}
                                    </span>
                                </div>
                            </div>
                            
                            <div class="inputs-container">
                                <div class="input-container birth">
                                    <label class="text-label">{{ "pt.edp.edponline.pack.health-plan.data-nascimento" | translate }}*</label>
                                    <input
                                        type="text"
                                        placeholder="{{ 'pt.edp.edponline.pack.health-plan.data-nascimento' | translate }}"
                                        formControlName="birthDate"
                                        [bsConfig]="{
                                            containerClass: 'theme-newui',
                                            dateInputFormat: 'DD/MM/YYYY',
                                            adaptivePosition: true,
                                            showWeekNumbers: false
                                        }"
                                        bsDatepicker
                                        [ngClass]="{ error: form.controls.birthDate.invalid && isSubmited }"
                                    />
                                    <span class="error" *ngIf="form.controls.birthDate.hasError('required') && isSubmited">
                                        {{ "pt.edp.edponline.form.requiredField" | translate }}
                                    </span>
                                    <span class="error" *ngIf="form.controls.birthDate.hasError('bsDate') && isSubmited">
                                        {{ "pt.edp.edponline.pack.invalidDate" | translate }}
                                    </span>
                                </div>
                                <div class="input-container fluid">
                                    <label class="text-label">{{ "pt.edp.edponline.pack.health-plan.email" | translate }}*</label>
                                    <input
                                        type="email"
                                        placeholder="{{ 'pt.edp.edponline.pack.health-plan.email' | translate }}"
                                        formControlName="email"
                                        [ngClass]="{ error: form.controls.email.invalid && isSubmited }"
                                    />
                                    <span class="error" *ngIf="form.controls.email.hasError('required') && isSubmited">
                                        {{ "pt.edp.edponline.form.requiredField" | translate }}
                                    </span>
                                    <span class="error" *ngIf="form.controls.email.hasError('pattern') && isSubmited">
                                        {{ "pt.edp.edponline.form.email-invalid" | translate }}
                                    </span>
                                </div>
                            </div>
                        </form>
                        <button class="btn btn-remove-mobile d-lg-none d-inline-block py-4" (click)="removeDependent(i)">
                            <i class="icon-edponline-Bra-068" aria-hidden="true"></i>
                            <span class="ml-2"><u>{{ "pt.edp.edponline.pack.health-plan.remove_beneficiary" | translate }}</u></span> 
                        </button>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
    <div class="row" *ngIf="LIMIT !== forms.length">
        <div class="col-12">
            <button class="btn btn-add mb-0 mb-md-4" (click)="addDependent()">
                <i class="icon-edponline-Bop-074" aria-hidden="true"></i>
                {{ "pt.edp.edponline.pack.health-plan.adicione" | translate }}
            </button>
        </div>
    </div>
    <div class="row px-4 px-md-0 mt-4">
        <div class="d-flex w-100 justify-content-end">
            <button class="btn btn-confirm text-uppercase" 
                [ngClass]="{ 'btn-pack-easy': pack.type === 1, 
                             'btn-pack-smart': pack.type === 2,
                             'btn-pack-full': pack.type === 3 }"
                [disabled]="disabledBtn" (click)="close()"
            >
                <span class="d-inline-block align-middle px-4">{{ "edpmodal.confirmar" | translate }}</span>
            </button>
        </div>
    </div>
</div>
